export const tailwindConfig = {
    fontFamily: {
      sans: ['Poppins', 'sans-serif'],
      montserrat: ['Poppins', 'sans-serif'],
    },
    extend: {
      colors: {
        primeval: {
          50:  '#F3F1FB',
          100: '#E3DBF6',
          200: '#C7B8ED',
          300: '#AB95E3',
          400: '#9174DB',
          500: '#8D78E1',
          600: '#7B61C8',
          700: '#664FAD',
          800: '#503C90',
          900: '#3A2B72',
          950: '#231A4D',
        },
      },
      fontSize: {
        heading: ['1rem', { lineHeight: '1.5rem', fontWeight: '700' }], 
        body: ['0.875rem', { lineHeight: '1.25rem', fontWeight: '500' }],
        '2xs': ['0.625rem', '0.75rem'],
      },
      height: {
        26: '6.5rem',
      },
      width: {
        26: '6.5rem',
      },
      minHeight: {
        18: '4.5rem',
      },
      borderWidth: {
        '1.5': '1.5px',
      },
    }
  };